import { createContext, useContext } from 'react';

export const ContentContext = createContext(null);

export const useContent = (name?: string) => {
  const content = useContext(ContentContext);
  if (name) {
    return content?.[name] || null;
  }
  return content;
};
